























// Importing components
import BaseSection from '../../ui/BaseSection.vue';

export default {
    name: 'TheWelcomeTags',
    components: {
        BaseSection,
    },
    props: {
        tags: Array,
        ekatte: String,
    },
};
